import React from 'react'
import JobBox from './JobBox'
import NoRecords from '../../components/noRecords/NoRecords'

const JobContainer = ({handlePageRefresh, handleStartJob,list, type, updateJobRequest, rejectJobRequest,handleMarkComplete, handleDispute, handleReview, acceptAndShare, handleInvoice, handleEndSelfieOpen }) => {
  return (
    <>
    {
      list?.length > 0 ?
      <div className={`w-100 ${type}`} >
        <div className='job-tab-content '>
          {
            list?.map((job, index) => {
              return (
                <JobBox
                handleStartJob={handleStartJob}
                  key={index}
                  type={type}
                  job={job}
                  updateJobRequest={updateJobRequest}
                  handleMarkComplete={handleMarkComplete}
                  handleDispute={handleDispute}
                  handleReview={handleReview}
                  acceptAndShare={acceptAndShare}
                  handleInvoice={handleInvoice}
                  handleEndSelfieOpen={handleEndSelfieOpen}
                  handlePageRefresh={handlePageRefresh}
                  rejectJobRequest={rejectJobRequest}
                 />
              )
            })
          }
        </div>
      </div>
      :
      <NoRecords />
    }
    </>

  )
}

export default JobContainer
